import { render, staticRenderFns } from "./NewModal.vue?vue&type=template&id=635c47c0&scoped=true&"
import script from "./NewModal.vue?vue&type=script&lang=ts&"
export * from "./NewModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewModal.vue?vue&type=style&index=0&id=635c47c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c47c0",
  null
  
)

export default component.exports